import { format, isValid, parseISO } from "date-fns";

// Coerces a Date, ISO string, or timestamp into a valid Date, or undefined if unparseable
export function toValidDate(
  value?: Date | string | number | null,
): Date | undefined {
  if (value == null || value === "") return undefined;

  const date =
    value instanceof Date
      ? value
      : typeof value === "string"
        ? parseISO(value)
        : new Date(value);

  if (isValid(date)) return date;

  // Fall back to the native parser for human-readable strings
  const fallback = new Date(value);
  return isValid(fallback) ? fallback : undefined;
}

// Formats a date-like value, returning fallback (default "") when it can't be parsed
export function safeFormat(
  value: Date | string | number | null | undefined,
  pattern: string,
  fallback = "",
): string {
  const date = toValidDate(value);
  return date ? format(date, pattern) : fallback;
}

// Normalizes a server datetime like "2026-08-14 10:13:26" (assumed +08:00) to a valid Date.
export function toServerDate(value?: string | null): Date | undefined {
  if (!value) return undefined;
  const normalized = value.trim().replace(" ", "T");
  const withTz = /[zZ]|[+-]\d{2}:?\d{2}$/.test(normalized)
    ? normalized
    : `${normalized}+08:00`;
  return toValidDate(withTz); // reuse existing util
}
